export default function () {
    return {
        loading: true,
        details: true,
    }
}